var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNuovo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1167,
    height: 467,
    viewBox: "0 0 1167 467",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M525.521 343.225C525.521 411.878 485.552 464.794 415.317 465.636C347.32 466.452 305.053 414.056 305.053 345.402C305.053 276.749 356.119 216.294 414.078 217.021C498.13 218.075 525.521 274.571 525.521 343.225Z",
    fill: "#171717",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M430.257 462.233C474.67 462.233 510.674 418.189 510.674 363.857C510.674 309.526 474.67 265.481 430.257 265.481C385.844 265.481 349.84 309.526 349.84 363.857C349.84 418.189 385.844 462.233 430.257 462.233Z",
    fill: "#373736",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M491.027 363.192C491.027 403.061 464.322 437.338 431.381 437.338C392.891 437.338 371.734 402.787 371.734 363.192C371.734 325.674 398.439 291.185 431.381 291.185C464.322 291.185 491.027 325.674 491.027 363.192Z",
    fill: "#F2F2F2",
    stroke: "#F2F2F2",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M448.047 377.114L435.341 379.808L452.916 416.308L448.753 432.988C443.265 435.149 437.431 436.315 431.381 436.315C422.709 436.315 414.931 434.543 408.101 431.316L425.878 387.11L419.669 374.679L398.566 404.409L382.388 405.879C375.934 393.707 372.578 378.856 372.578 363.214C372.578 361.413 372.635 359.613 372.765 357.826L411.545 365.749L419.395 354.672L391.277 336.278L384.766 320.894C393.251 307.411 405.582 297.329 419.756 293.685L423.718 341.953L434.262 347.643L442.647 307.887L452.141 297.026C464.631 303.004 475.088 314.082 481.859 327.737L446.437 348.723L444.275 363.315L479.698 357.107L490.185 364.54C489.926 381.71 484.669 397.742 476.082 410.288L448.049 377.114H448.047Z",
    fill: "#1A1A1A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M430.146 369.865C432.805 369.865 434.961 367.29 434.961 364.114C434.961 360.937 432.805 358.362 430.146 358.362C427.487 358.362 425.331 360.937 425.331 364.114C425.331 367.29 427.487 369.865 430.146 369.865Z",
    fill: "#FDFDFE",
    stroke: "white",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M430.146 368.102C431.987 368.102 433.479 366.319 433.479 364.121C433.479 361.922 431.987 360.14 430.146 360.14C428.305 360.14 426.813 361.922 426.813 364.121C426.813 366.319 428.305 368.102 430.146 368.102Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1113.79 315.683C1113.79 380.395 1072.38 433.542 1014.02 432.855C945.308 432.045 921.371 380.396 921.371 315.683C921.371 250.971 961.604 216.116 1014.02 216.116C1066.43 216.116 1113.79 244.412 1113.79 315.683Z",
    fill: "#171717",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.61 428.739C1069.92 428.739 1099.35 388.621 1099.35 339.132C1099.35 289.643 1069.92 249.524 1033.61 249.524C997.304 249.524 967.871 289.643 967.871 339.132C967.871 388.621 997.304 428.739 1033.61 428.739Z",
    fill: "#373736",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.61 405.568C1061.44 405.568 1084 375.763 1084 338.997C1084 302.23 1061.44 272.425 1033.61 272.425C1005.78 272.425 983.22 302.23 983.22 338.997C983.22 375.763 1005.78 405.568 1033.61 405.568Z",
    fill: "#F2F2F2",
    stroke: "#F2F2F2",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.21 350.869L1037.14 353.041L1052.37 386.201L1047.8 402.086C1043.31 403.852 1038.54 404.793 1033.62 404.793C1027.15 404.793 1021 403.171 1015.33 400.216L1029.79 361.191L1024.36 348.144L1007.22 375.599L992.682 376.525C987.074 365.881 983.786 352.951 983.786 339.006C983.786 336.934 983.858 334.893 984.003 332.88L1017.29 341.077L1023.81 330.752L1002.06 313.896L995.334 296.896C1002.56 285.427 1012.69 277.274 1024.24 274.378L1027.08 318.24L1036.33 324.496L1043.67 287.252L1050.93 277.304C1061.79 282.603 1070.86 292.755 1076.62 305.774L1044.76 325.583L1043.4 338.63L1073.32 332.649L1083.44 340.903C1083.09 356.6 1078.58 370.922 1071.34 382.013L1047.21 350.865V350.869Z",
    fill: "#1A1A1A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.61 345.02C1036.34 345.02 1038.55 342.382 1038.55 339.127C1038.55 335.873 1036.34 333.235 1033.61 333.235C1030.89 333.235 1028.68 335.873 1028.68 339.127C1028.68 342.382 1030.89 345.02 1033.61 345.02Z",
    fill: "#FDFDFE",
    stroke: "white",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.61 343.208C1035.5 343.208 1037.03 341.382 1037.03 339.13C1037.03 336.878 1035.5 335.052 1033.61 335.052C1031.73 335.052 1030.2 336.878 1030.2 339.13C1030.2 341.382 1031.73 343.208 1033.61 343.208Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M822.729 363.45C813.895 401.313 798.979 431.165 745.594 430.291C690.321 431.165 671.257 402.634 665.467 363.45H822.729Z",
    fill: "#2C2C2B",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M822.73 363.44C820.159 393.64 797.683 430.175 753.277 430.175C721.548 428.755 694.982 404.078 686.742 363.44H822.73Z",
    fill: "#171717",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M240.669 372.991C234.391 408.589 211.083 445.094 154.24 444.163C95.3845 445.094 71.726 407.747 64.8171 372.991H240.667H240.669Z",
    fill: "#2C2C2B",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M240.669 372.981C234.955 407.46 212.35 441.892 162.42 444.04C120.892 442.575 96.2444 416.251 87.4722 372.981H240.671H240.669Z",
    fill: "#171717",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M164.72 400.371C168.635 400.371 171.809 397.558 171.809 394.088C171.809 390.619 168.635 387.806 164.72 387.806C160.806 387.806 157.632 390.619 157.632 394.088C157.632 397.558 160.806 400.371 164.72 400.371Z",
    fill: "#D9E3F0",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M288.212 130.627C293.212 129.807 429.802 15.4118 529.823 8.98843C626.151 -1.79157 959.769 -6.56722 1038.57 25.5977C1038.57 25.5977 1092.8 35.2193 1085.77 45.8946C1085.77 45.8946 1083.38 50.8109 1079.59 55.4459C1079.59 55.4459 1151.86 123.99 1153.55 138.107L1158.92 141.092C1158.92 141.092 1161.03 167.534 1159.98 200.822C1159.98 200.822 1158.33 201.313 1156.85 201.524C1156.85 201.524 1159.06 214.271 1156.85 228.457C1156.85 228.457 1164.23 237.586 1164.37 244.751C1164.51 251.915 1164.58 263.115 1163.21 275.441C1163.21 275.441 1165.88 276.425 1166.16 279.234C1166.44 282.043 1164.75 302.48 1163.28 307.958C1161.8 313.436 1146.84 335.347 1143.89 337.243C1140.94 339.14 1126.62 347.217 1104.7 353.959C1104.7 353.959 1119.87 327.553 1110.6 284.852C1101.33 242.153 1065.37 217.15 1029.13 225.016C992.887 232.883 966.759 252.546 953.274 328.396C953.274 328.396 952.29 345.813 937.12 373.343L513.459 393.007C513.459 393.007 522.309 382.05 523.152 374.256C523.995 366.46 523.438 325.305 516.134 296.651C508.83 267.997 483.944 244.761 451.793 241.585C431.823 240.74 398.468 240.205 372.128 265.549C354.745 282.273 340.2 309.173 335.342 358.594C335.342 358.594 334.358 368.706 332.673 373.763C330.988 378.82 323.964 400.451 318.345 400.169C312.726 399.888 225.986 397.149 211.025 393.988C211.025 393.988 67.5607 383.613 40.1679 378.556C40.1679 378.556 4.34712 370.128 0.695144 359.664C0.695144 359.664 0.554459 350.183 6.17311 348.498C11.7918 346.813 -0.921298 290.698 13.4067 268.786C13.4067 268.786 8.67412 245.378 17.6649 206.611C17.6649 206.611 14.3901 202.068 25.4178 192.938C40.9402 179.454 55.5496 178.05 59.2016 175.521C92.3522 153.891 187.07 144.224 260.497 138.088C269.753 137.256 278.983 131.111 288.213 130.626L288.212 130.627Z",
    fill: "#3E3E3E",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1958 177.213C92.3479 155.573 187.075 145.92 260.488 139.769L59.1958 177.213Z",
    fill: "#333333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M555.81 149.201C555.81 149.201 556.091 143.231 557.566 140.281C559.04 137.331 609.961 71.5255 652.945 44.9789C695.929 18.4322 810.975 10.4254 999.347 34.8664C999.347 34.8664 1019.5 39.1152 1027.3 47.5425C1035.1 55.9699 1071.76 93.6483 1071.48 106.712C1071.2 119.774 974.342 126.939 974.342 126.939C974.342 126.939 719.598 145.269 555.808 149.202L555.81 149.201Z",
    fill: "#E6E6E6",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M974.336 126.929C974.336 126.929 960.027 127.962 935.99 129.578C935.915 127.468 934.718 89.5743 933.91 82.7499C933.131 76.1948 904.275 30.3689 900.503 24.3975C905.802 24.8165 911.175 25.2655 916.638 25.7594C919.781 30.7131 952.11 82.1213 974.336 126.929Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M593.318 97.5225V148.107C580.417 148.541 567.859 148.916 555.811 149.2C555.811 149.2 556.095 143.229 557.562 140.28C558.355 138.709 573.158 119.313 593.318 97.5225Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M581.749 4.9834C432.063 16.1181 367.286 82.1031 298.961 131.132C292.061 130.832 288.214 130.653 288.214 130.653C293.213 129.83 429.803 15.4297 529.828 9.00925C543.074 7.52762 560.81 6.15075 581.749 4.9834Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M641.205 37.0081C591.679 71.2802 531.242 132.476 528.383 135.38C441.32 136.711 332.943 132.551 298.908 131.129C344.093 98.6829 387.737 58.8435 455.434 32.3387C467.707 31.6503 584.121 25.4693 641.205 37.0081Z",
    fill: "#E6E6E6",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M561.848 134.563C551.199 134.923 539.975 135.192 528.394 135.357",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.58 25.599C860.083 -5.48534 704.641 7.45874 686.202 15.0435C674.722 18.2223 658.059 25.3296 641.203 36.9732L635.979 36.0004C634.797 35.7908 633.585 35.5813 632.357 35.4017C636.728 31.8847 670.978 5.88881 729.657 4.33235C788.8 2.74596 878.915 4.22758 889.543 4.40718C955.752 8.01398 1011.84 14.6738 1038.58 25.599H1038.58Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M890.792 4.48051C880.165 4.29792 790.063 2.31494 730.928 3.92677C672.437 5.50868 636.805 31.8174 632.27 35.5125C572.82 25.9926 468.36 31.7111 456.686 32.3651C490.826 18.77 531.073 8.65602 580.733 4.70201C660.254 0.0640506 787.758 -1.2365 890.792 4.48051Z",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9448 208.899C16.9448 208.899 222.286 216.234 278.585 205.277C278.585 205.277 285.75 198.465 293.265 197.411C348.37 186.797 443.738 174.277 561.499 166.761",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M370.586 185.13C367.099 188.856 319.908 238.888 312.813 239.846C305.434 240.848 279.137 241.731 273.105 241.073L272.956 233.859C249.023 233.275 219.104 231.943 219.104 231.943C219.104 231.943 188.811 218.25 188.482 217.262C188.182 216.394 188.317 212.203 188.362 211.051C226.034 210.482 260.204 208.851 278.583 205.274C278.583 205.274 285.753 198.465 293.266 197.417C313.771 193.466 339.844 189.246 370.586 185.13Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M338.571 189.681C338.017 190.324 320.266 210.992 316.389 218.745C312.483 226.542 309.475 232.483 306.331 240.415C301.542 240.73 295.361 240.999 289.553 241.149C289.464 234.459 291.245 226.766 291.245 226.766L217.921 225.928C213.281 225.075 196.278 217.757 196.278 217.757L196.503 213.477C196.503 213.477 288.58 211.86 294.193 211.86C294.193 211.86 301.796 201.01 312.154 193.976H312.169C320.341 192.554 329.156 191.117 338.571 189.681Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M196.278 217.757C196.278 217.757 305.923 220.53 315.616 219.897",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M291.034 227.4C291.245 224.45 294.194 211.849 294.194 211.849L320.287 212.371",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M216.797 212.659L216.515 218.418L217.358 226.003",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M234.635 212.659L234.353 218.418L235.197 226.003",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M253.036 212.659L252.754 218.418L253.597 226.003",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M272 212.659L271.719 218.418L272.562 226.003",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M291.245 226.761L312.175 227.548",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M289.945 233.87L309.12 234.291",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M300.585 204.06L327.033 203.743",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M285.01 267.431C285.01 267.431 295.545 258.371 300.603 259.424C300.603 259.424 304.466 260.969 304.325 265.324C304.184 269.679 305.027 315.749 305.027 315.749C305.027 315.749 305.097 323.018 302.043 321.753C298.988 320.488 285.187 314.484 284.66 308.269C284.133 302.053 282.939 269.993 285.012 267.429L285.01 267.431Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M287.421 269.292C287.421 269.292 294.104 263.709 300.429 263.499C300.429 263.499 302.099 301.284 301.463 315.611C301.463 315.611 289.768 313.117 288.217 309.325L287.421 269.294V269.292Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M287.844 274.03L300.878 273.714",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M287.959 281.722L301.109 281.302",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M287.959 289.299L301.341 288.772",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M288.075 296.471L301.691 296.155",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M288.192 304.163L301.576 303.636",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8724 220.46C14.618 222.001 14.3785 223.498 14.1689 224.964C22.9696 221.193 33.8507 216.449 34.0602 215.865C34.3745 215.012 34.3596 210.657 34.3446 209.49L31.8152 209.415L29.4803 209.34C29.2857 209.34 29.1061 209.325 28.9265 209.325C27.2203 209.295 25.529 209.25 23.8527 209.175C23.7629 209.175 23.6581 209.16 23.5533 209.16C21.3981 209.056 19.2727 208.951 17.1474 208.831C16.9379 209.699 16.7582 210.567 16.5936 211.42C16.2494 213.007 15.9351 214.563 15.6507 216.09",
    fill: "#1A1A1A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8724 220.46C14.618 222.001 14.3785 223.498 14.1689 224.964C22.9696 221.193 33.8507 216.449 34.0602 215.865C34.3745 215.012 34.3596 210.657 34.3446 209.49L31.8152 209.415L29.4803 209.34C29.2857 209.34 29.1061 209.325 28.9265 209.325C27.2203 209.295 25.529 209.25 23.8527 209.175C23.7629 209.175 23.6581 209.16 23.5533 209.16C21.3981 209.056 19.2727 208.951 17.1474 208.831C16.9379 209.699 16.7582 210.567 16.5936 211.42C16.2494 213.007 15.9351 214.563 15.6507 216.09",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5945 211.419C16.2503 213.005 15.936 214.562 15.6516 216.088L16.5945 211.419Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5945 211.419C16.2503 213.005 15.936 214.562 15.6516 216.088L14.8733 220.458",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.01 285.853C1165.58 293.081 1164.38 305.383 1163.27 309.454C1161.81 314.931 1146.84 336.842 1143.89 338.742C1140.94 340.628 1126.62 348.71 1104.69 355.444C1104.69 355.444 1115.75 336.198 1113.22 303.991C1113.93 303.902 1119.46 303.183 1124.67 300.624C1130.24 297.885 1147.74 290.507 1159.49 288.606C1159.49 288.606 1164.35 287.274 1166.01 285.853Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M952.522 333.547C951.175 340.625 947.418 354.664 937.121 373.341L513.462 393.006C513.462 393.006 521.574 382.051 522.413 374.254C522.742 371.261 522.748 363.359 523.167 353.137C529.139 352.478 606.183 344.038 612.649 343.634C619.399 343.215 873.077 329.73 881.518 330.149C889.825 330.568 948.137 334.25 952.522 333.547Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M551.548 318.821L944.445 298.033C944.445 298.033 887.937 269.379 847.954 272.749C807.971 276.12 620.319 283.986 604.325 290.167C604.325 290.167 566.475 304.212 551.548 318.821Z",
    fill: "#606060"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.62 187.7H1034.87C1029.33 187.7 1027.2 183.346 1024.8 177.631L1018.21 157.758C1015.82 150.197 1020.35 147.688 1025.89 147.688H1054.1C1059.64 147.688 1066.04 152.024 1067.94 157.758L1073.13 177.631C1073.13 183.17 1071.16 187.7 1065.62 187.7H1065.62Z",
    stroke: "black",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9862 263.495C66.5777 256.699 101.712 230.523 125.627 215.728C126.325 215.297 127.1 216.127 126.555 216.727C119.298 224.724 82.9727 253.182 60.8424 264.547C60.1284 264.913 59.4354 264.062 59.9877 263.495H59.9862Z",
    fill: "#F2F2F2",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2606 259.49C101.256 259.49 107.737 250.819 107.737 240.122C107.737 229.426 101.256 220.755 93.2606 220.755C85.2656 220.755 78.7844 229.426 78.7844 240.122C78.7844 250.819 85.2656 259.49 93.2606 259.49Z",
    fill: "#F4F4F3",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2589 254.789C99.0113 254.789 103.674 248.34 103.674 240.384C103.674 232.429 99.0113 225.979 93.2589 225.979C87.5065 225.979 82.8433 232.429 82.8433 240.384C82.8433 248.34 87.5065 254.789 93.2589 254.789Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M183.875 328.011L284.091 309.778C286.211 315.615 296.655 320.192 299.764 321.588L183.875 328.011Z",
    fill: "#4D4D4D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M555.809 149.202C555.809 149.202 555.218 157.767 556.903 160.491C558.588 163.215 561.118 164.68 561.749 171.174C562.381 177.667 564.91 228.499 562.662 349.155C562.662 349.155 562.171 370.591 559.923 373.105C559.923 373.105 561.188 388.188 559.783 391.12",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M334.18 366.648C333.806 369.836 333.3 372.027 332.073 375.708C330.382 380.767 323.962 402.105 318.335 401.821C312.722 401.552 225.988 398.813 211.021 395.64C211.021 395.64 67.5608 385.269 40.171 380.21C40.171 380.21 4.33976 371.784 0.68779 361.323C0.68779 361.323 0.553087 351.925 6.09092 350.188C75.9873 363.254 261.484 376.123 334.179 366.65L334.18 366.648Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M202.284 368.509C131.145 366.773 54.1977 358.377 11.8557 351.223C11.9904 349.771 14.1457 311.219 17.2888 302.703C19.8931 295.669 27.9154 296.328 27.9154 296.328L152.831 304.095C152.831 304.095 166.72 304.664 171.345 308.72C174.638 311.399 198.048 360.143 198.048 360.143C198.048 360.143 202.643 365.695 202.284 368.509Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M298.113 258.879C292.915 259.494 284.352 266.799 284.276 267.008C235.708 271.539 214.076 276.503 168.32 277.673C140.066 278.821 48.8389 277.851 14.2649 270.683C14.2649 270.593 13.8009 268.078 13.4268 263.454C41.2207 268.168 111.692 271.236 156.765 270.31C201.397 267.257 254.39 260.723 254.39 260.723C254.39 260.723 291.361 257.293 298.112 258.879H298.113Z",
    fill: "#333333"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.97 200.821C1159.97 200.821 1158.32 201.315 1156.85 201.524L1153.55 138.099L1158.92 141.092C1158.92 141.092 1161.03 167.522 1159.97 200.821Z",
    fill: "#F15A24",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.46 248.992L1118.23 256.58L1155.91 230.569C1155.91 230.569 1163.28 239.699 1163.42 246.867C1163.43 247.541 1163.45 248.244 1163.46 248.992Z",
    fill: "#4D4D4D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M761.415 21.2788C761.849 26.2924 767.447 91.6938 762.583 140.288C771.055 139.818 779.432 139.346 787.703 138.871C787.39 104.229 778.002 44.6288 772.106 20.7939C768.474 20.9316 764.904 21.0903 761.415 21.2788Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M784.958 20.4033C780.574 20.4991 776.295 20.6278 772.106 20.7865C778.002 44.6213 787.389 104.222 787.703 138.864C793.677 138.521 799.602 138.18 805.433 137.841C804.176 78.2768 786.889 26.0754 784.958 20.4033Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M773.712 182.813L737.035 184.522C735.384 184.598 734.662 183.301 733.905 181.671L732.218 177.618C731.692 176.127 733.417 174.565 735.07 174.489L771.746 172.779C773.397 172.703 774.152 174.043 774.876 175.63L776.563 179.683C777.117 181.111 775.364 182.736 773.712 182.813Z",
    stroke: "black",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M973.494 170.692L942.231 172.148C940.822 172.214 940.2 170.91 939.543 169.278L938.076 165.214C937.616 163.719 939.077 162.172 940.486 162.106L971.749 160.65C973.157 160.584 973.808 161.929 974.437 163.52L975.904 167.584C976.386 169.014 974.903 170.626 973.494 170.692Z",
    stroke: "black",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M772.244 21.3213C778.139 45.1561 787.413 103.586 787.726 138.228",
    stroke: "#333333",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M233.515 272.798L171.605 307.256C166.98 303.2 152.905 302.778 152.905 302.778L28.1244 295.034C28.1244 295.034 18.4571 294.192 16.0863 303.727C13.8996 312.522 11.4645 348.372 11.3148 349.958C9.33916 349.629 7.89036 349.352 7.89036 349.352C11.1696 345.982 0.806426 292.32 13.8353 269.847C48.4093 277.015 141.12 279.275 168.401 278.011C194.997 277.337 212.953 275.113 233.515 272.796V272.798Z",
    fill: "#4D4D4D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M287.82 184.805C302.709 176.096 342.041 160.786 538.702 147.864L287.82 184.805Z",
    fill: "#333333"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M970.289 128.085H970.124C951.909 129.372 886.144 133.952 806.145 138.651C726.146 143.365 631.738 148.184 556.588 149.995C556.588 149.995 555.911 158.548 558.466 161.355C559.954 163.21 561.195 164.795 561.986 167.88L1152.89 140.582C1152.85 135.788 1150.64 132.909 1144.81 124.867C1144.81 124.867 1035.92 123.631 970.289 128.085Z",
    fill: "#4D4D4D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.95 234.496C1004.36 219.607 1003.02 202.854 1003.02 202.854C1001.34 175.141 991.645 147.222 991.645 147.222C991.645 147.222 989.118 142.259 983.779 138.951C978.442 135.642 974.344 126.946 974.344 126.946",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M787.542 138.812C787.542 138.812 794.003 153.731 795.127 155.124C796.251 156.518 798.498 227.488 788.946 278.241C788.946 278.241 787.401 297.482 789.929 305.847C792.457 314.211 789.789 329.272 791.053 334.29C791.053 334.29 788.244 353.6 784.872 363.918C784.872 363.918 785.996 374.514 784.311 380.65",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M203.349 191.368C252.092 168.544 332.582 156.113 417.426 146.702L203.349 191.368Z",
    fill: "#383838"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M632.278 140.354H619.424V148.044H632.278V140.354Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M592.173 155.687C592.173 155.687 601.866 147.4 608.468 146.697C615.07 145.993 645.272 142.482 649.485 143.326C653.7 144.169 654.683 146.697 654.683 146.697C654.683 146.697 655.807 153.158 651.874 153.58C647.941 154.002 622.375 156.811 622.375 156.811V161.868C622.375 161.868 613.947 163.553 610.295 162.57C606.643 161.586 592.456 157.935 592.175 155.687H592.173Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M601.667 126.217C601.667 126.217 604.602 100.878 628.651 104.047C652.701 107.215 667.685 110.555 668.813 120.397C669.942 130.24 665.456 136.391 657.162 137.63C648.867 138.869 614.365 144.995 606.532 138.955C606.532 138.955 600.421 135.176 601.665 126.217H601.667Z",
    fill: "#4D4D4D",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M667.836 125.833C666.893 132.203 663.353 135.875 657.073 136.806C648.779 138.036 614.654 144.115 606.823 138.084C606.823 138.084 603.187 135.684 602.547 129.398C605.744 129.54 634.534 130.883 667.836 125.833Z",
    fill: "#333333"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.05 63.4701C1082.87 58.4416 1079.59 55.3286 1079.59 55.3286C1082.17 52.1708 1084.1 48.8783 1085.09 47.1123C1085.32 48.145 1087.24 56.5858 1088.05 63.4701Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuovo);
export default __webpack_public_path__ + "static/media/nuovo.76d58fd2fc1c7b9b1d773e541d472025.svg";
export { ForwardRef as ReactComponent };